import { useAppDispatch } from 'src/store/hooks';
import {
  handleModalPurchaseError,
  handleModalPurchaseSuccess
} from 'src/store/actions/modal';
import { Button } from '../reusable/Buttons';
import Image from '../reusable/Image';
import { H5, Paragraph } from '../reusable/Typography';
import * as SVG from 'src/assets/icons';
import { storageGet } from 'src/utils';

const PurchaseError = () => {
  const dispatch = useAppDispatch();
  const purchaseSummary: IPurchaseSummary = storageGet('purchase_summary');

  const handleConfirmPurchase = () => {
    if (purchaseSummary.fullname.includes('Alayo')) {
      dispatch(handleModalPurchaseSuccess(true));
    } else {
      dispatch(handleModalPurchaseError(true));
    }
  };

  return (
    <div className="relative h-[calc(100vh-1600px)] container mx-auto flex justify-center">
      <div className="absolute top-1/2 transform translate-y-1/2 max-w-md">
        <div className="flex justify-center mb-10">
          <Image className="w-40 h-40" src={SVG.RedErrorGiftCard} />
        </div>
        <div className="text-center">
          <H5 className="font-medium mb-2">Unsuccessful purchase</H5>
          <Paragraph>
            Your purchase of 2($80) gift cards to Solaru Olusegun was
            unsuccessful due to reason. Click the button below to try again.
          </Paragraph>
        </div>
        <div>
          <Button
            onClick={handleConfirmPurchase}
            className="w-[450px] mt-10 text-sm"
          >
            Try again
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PurchaseError;
